import { Info } from 'lucide-react';
import { Tooltip } from '../../../components/common/Tooltip';
import HoverPillButton from '../../../components/common/HoverPillButton';
import { ThreeDotsIcon } from '../../../components/common/selectIcons';

const ReplaceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
  </svg>
);

interface Props {
  /** モバイル3点メニューの開閉判定キー (スロット識別子) */
  menuId: string;
  replaceTooltip: string;
  deleteTooltip: string;
  onReplace: () => void;
  onDelete: () => void;
  /** 指定するとモバイル3点メニューに「名前を編集」を表示する (PCは ImageNameButton 側) */
  onEditName?: () => void;
  replaceDisabled?: boolean;
  openActionMenu: string | null;
  setOpenActionMenu: (v: string | null) => void;
}

/**
 * 商品画像スロットの「差替」「削除」ホバーボタンと、モバイル用3点メニュー。
 * Amazon / マニュアル商品詳細ページで共用する。
 */
export function SlotActionButtons({
  menuId,
  replaceTooltip,
  deleteTooltip,
  onReplace,
  onDelete,
  onEditName,
  replaceDisabled,
  openActionMenu,
  setOpenActionMenu,
}: Props) {
  return (
    <>
      <Tooltip content={replaceTooltip} className="replace-button-corner-wrapper">
        <HoverPillButton
          variant="default"
          label="差替"
          icon={<ReplaceIcon />}
          onClick={(e) => {
            e.stopPropagation();
            onReplace();
          }}
          disabled={replaceDisabled}
        />
      </Tooltip>
      <Tooltip content={deleteTooltip} className="delete-button-corner-wrapper">
        <HoverPillButton
          variant="danger"
          label="削除"
          icon={<img src="/bin_1_white.svg" alt="削除" />}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        />
      </Tooltip>
      {/* モバイル用3点メニュー */}
      <div className="slot-action-menu-wrapper">
        <button
          className="slot-action-menu-trigger"
          onClick={(e) => {
            e.stopPropagation();
            setOpenActionMenu(openActionMenu === menuId ? null : menuId);
          }}
        >
          <ThreeDotsIcon vertical />
        </button>
        {openActionMenu === menuId && (
          <div className="slot-action-menu-dropdown">
            {onEditName && (
              <button
                className="slot-action-menu-item"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenActionMenu(null);
                  onEditName();
                }}
              >
                <Info size={14} />
                名前を編集
              </button>
            )}
            <button
              className="slot-action-menu-item"
              onClick={(e) => {
                e.stopPropagation();
                setOpenActionMenu(null);
                onReplace();
              }}
            >
              <ReplaceIcon />
              差替
            </button>
            <button
              className="slot-action-menu-item danger"
              onClick={(e) => {
                e.stopPropagation();
                setOpenActionMenu(null);
                onDelete();
              }}
            >
              <img src="/bin_1_white.svg" alt="削除" />
              削除
            </button>
          </div>
        )}
      </div>
    </>
  );
}
